import { Stack, Text } from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  List,
  ListItem,
  Modal,
  PrimaryButton,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export interface FCARegulatedReferencesLearnMoreModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function FCARegulatedReferencesLearnMoreModal({
  isOpen,
  onClose,
}: FCARegulatedReferencesLearnMoreModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} testID="fca-regulated-references-learn-more-modal">
      <Dialog width="560px">
        <DialogHeader
          onClose={onClose}
          testID="fca-regulated-references-learn-more-header"
        >
          {t("FCA regulated references")}
        </DialogHeader>
        <DialogContent>
          <Stack gap="space-4">
            <Text style="form/body-primary">
              {t(
                "FCA regulated references are required for certain roles in UK financial services."
              )}
            </Text>
            <Stack gap="space-2">
              <Text style="global/heading-small">{t("When enabled:")}</Text>
              <List type="unordered">
                <ListItem>
                  <Text style="form/body-primary">
                    {t(
                      "References are requested from applicable FCA-regulated employers"
                    )}
                  </Text>
                </ListItem>
                <ListItem>
                  <Text style="form/body-primary">
                    {t(
                      "Applicants may be asked to identify whether previous roles were regulated"
                    )}
                  </Text>
                </ListItem>
                <ListItem>
                  <Text style="form/body-primary">
                    {t("A standard FCA reference template is used")}
                  </Text>
                </ListItem>
                <ListItem>
                  <Text style="form/body-primary">
                    {t(
                      "Your FCA firm reference number (FRN) is required to request these references"
                    )}
                  </Text>
                </ListItem>
              </List>
            </Stack>
            <Stack gap="space-2">
              <Text style="global/heading-small">{t("What is an FRN?")}</Text>
              <Text style="form/body-primary">
                {t(
                  "An FRN is the Financial Conduct Authority's firm reference number. It identifies the firm requesting the regulated reference."
                )}
              </Text>
            </Stack>
            <Stack gap="space-2">
              <Text style="global/heading-small">
                {t("When should I use this?")}
              </Text>
              <Text style="form/body-primary">
                {t(
                  "Use this if you are hiring for FCA-regulated roles in the UK."
                )}
              </Text>
            </Stack>
          </Stack>
        </DialogContent>
        <DialogFooter>
          <PrimaryButton
            size="medium"
            onPress={onClose}
            testID="fca-regulated-references-learn-more-close"
          >
            {t("Close")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
